exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login__page{width:600px;display:inline-block;margin-left:32px;margin-right:32px;text-align:left}.login__content{margin-top:24px}.login__title{margin-top:40px;font-weight:700;font-size:24px}.login__text-block{padding-top:8px}.login__list{margin:0;padding:0;list-style-position:inside}.login__show-token-link{display:inline-block;padding-top:8px;margin-left:-6px}.login__token-location{padding:4px;padding-left:11px}.login__button-wrapper{margin-top:12px}.login__input-wrapper{position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/pages/login/login.scss
// module id = 835
// module chunks = 0